/**
 * Global
 * ------
 */

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if( isIE11 ){
  $b.addClass('legacy-browser');
  $('.bg-video').remove();
}

 var searchClose = function(){
  $b.removeClass('search-open');
  $('#site-search-field').attr('tabindex','-1');
  $('#site-search-submit').attr('tabindex','-1');
 };
 var dropdownClose = function(){
  $('.dropdown').removeClass('is-open').find('.options a').attr('tabindex','-1');
 };
 var menuDropdownClose = function(){
  $('.level-1 > .item').removeClass('is-open');
  $('#site-menu .dropdown a').attr('tabindex','-1');
 };
 var modalClose = function(){
  var $embed = $('.modal.shown .modal-body iframe');
  if ($embed.length) {
    var newSrc = $embed[0].src;
    newSrc = newSrc.replace('&autoplay=1', '');
    $embed[0].src = newSrc;
  }
  $('.modal').removeClass('shown');
};


 $b.on('keyup', function(e){
  // keyCode is getting deprecated use key instead when supported, which makes this messy
  evt = e || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key == "Escape" || evt.key == "Esc");
  } else {
    isEscape = (evt.keyCode == 27);
  }
  if (isEscape) {
    searchClose();
    dropdownClose();
    menuDropdownClose();
    modalClose();
  }
 });

/*
WP columns -> Bootstrap
*/
// $('.wp-block-columns').each(function(){
//   let $this = $(this);
//   $this.addClass('row');
//   let colCount = $(this).find('.wp-block-column').length;
//   $this.find('.wp-block-column').each(function(){
//     if ($(this).attr('class').indexOf('col-') < 0) {
//       // automatic column size based on column count
//       $(this).addClass('col-md-' + Math.floor(12/colCount));
//     } else {
//       // admin has set columns, so remove WP's inlined flex-basis
//       $(this).removeAttr('style');
//     }
//   });
// });

// extra markup for our fancy buttons
$('.btn-enhanced, .is-style-outline .wp-block-button__link').append(window.app.btnBorder);

// header adjustments
if (!$('#site-message').length) {
  $b.addClass('no-message');
}
// keep the navigation theme synced to hero color
if ($('.page-title.has-image').length || $('.feature').length) {
  let $featureEl = $('.feature').first();
  // if our feature is shown on a collection after the grid, it's not a hero
  // .has-hero on body without actually having a hero causes the page title to crash into the nav
  let ignoreFeature = $featureEl.closest('#collection-feature').length === 1 && $('.page-title.has-image').length === 0;
  var color = $('.page-title').length ? $('.page-title').data('color') : $featureEl.data('color');
  if (!$('.page-title').hasClass('is-static') && !ignoreFeature) {
    $b.addClass('has-hero');
  }
  $('#site-header').removeClass('color-white').addClass('color-' + color);
}

if( $w.scrollTop() > 30 ){
  $('#site-header').addClass('is-scrolled');
}
$w.on('scroll', function(){
  if( $w.scrollTop() > 30 ){
    $('#site-header').addClass('is-scrolled');
  }else{
    $('#site-header').removeClass('is-scrolled');
  }
});

// search modal
$('#search-open').on('click', function(e){
  e.preventDefault();
  if( $b.hasClass('template-search') ){
    $('#ais-search .ais-SearchBox-input').select();
  } else {
    $b.addClass('modal-open');
    $('#search-modal').addClass('shown');
    $('#aac .ais-SearchBox-input').select();
  }
  // $('#site-search-submit').attr('tabindex','0');
});

// site menu click to open (less obnoxious than reacting to hover)
$('#site-menu .level-1 .item > a.has-dropdown').on('click', function(e){
  e.preventDefault();
  let $parent = $(this).closest('.level-1 > .item');
  if ($parent.hasClass('is-open')){
    menuDropdownClose();
  }else{
    menuDropdownClose();
    $parent.addClass('is-open');
    $parent.find('.dropdown a').attr('tabindex','0');
  }
});

/*
Mobile Menu
*/
$('#menu-open').on('click', function(e){
  e.preventDefault();
  $b.addClass('menu-open');
});
$('#menu-close').on('click', function(e){
  e.preventDefault();
  menuDropdownClose();
  $b.removeClass('menu-open');
});
$('.panel-close a').on('click', function(e){
  e.preventDefault();
  $(this).closest('.is-open').removeClass('is-open');
});

const protectNavbar = function(){
  // makre sure the first feature is tall enough to keep its content out of the navbar
  if ($b.hasClass('has-hero')) {
    let $hero = $('.feature').first();
    if ($hero.hasClass('as-page-hero')) return; // as-page-hero is not 100vh, so we don't need to worry about crashing
    if ($hero.hasClass('video-true')) return; // videos have an auto height rather than 100vh
    if ($hero.closest('#collection-feature').length === 1) return; // ignore the collection feature after the product grid
    if ($w.outerWidth() >= window.app.breakpoints.md) {
      $hero.css({
        'padding-top': $('#site-header').outerHeight(),
        'padding-bottom': 25
      });
    } else {
      $hero.css({'padding':0});
    }
  }
}
protectNavbar();
$w.on('resize', function(){
  protectNavbar();
});

$('#site-menu .level-2 .has-children').on('click', function(e){
  if( $w.width() < app.breakpoints.lg ){
    e.preventDefault();
    let $parent = $(this).closest('.level-2 > .item');
    $parent.addClass('is-open');
    $parent.find('.dropdown a').attr('tabindex','0');
  }
});

// dropdowns
$b.on('click', '.dropdown .trigger', function(e){
  e.preventDefault();
  e.stopPropagation();
  $(this).blur(); // prevent focus from staying active
  let $parent = $(this).closest('.dropdown');
  if ($parent.hasClass('is-open')) {
    // safe to close all drop downs
    dropdownClose();
  }else{
    // close other drop downs and open this one
    dropdownClose();
    $parent.addClass('is-open');
    $parent.find('.options a').attr('tabindex','0')
  }
});
$b.on('click', function(){
  dropdownClose();
});

/*
Sharing
*/
$('#sharing-trigger').on('click', function(e){
  e.preventDefault();
  $('.sharing-options').addClass('is-shown');
  $('.sharing-options a').attr('tabindex','0');
});
$('.sharing-options a.in-window').on('click', function(e){
  e.preventDefault();
  window.open($(this).attr('href'), 'shareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
});

/*
Footer
*/
$('.menu-title').on('click', function(e){
  e.preventDefault();
  var $parent = $(this).closest('.footer-menu');
  $parent.toggleClass('is-open');
});
var updateFooterDom = function(){
  var socialSelector = '#social-profiles';
  var $footerContent = $('#footer-content');
  var $social = $(socialSelector);
  var $legal = $('#legal');
  if ($w.width() < app.breakpoints.md) {
    if (!$footerContent.find(socialSelector).length) {
      $social.detach().prependTo($footerContent);
    }
  }else{
    if (!$legal.prev(socialSelector).length) {
      $social.detach().insertBefore($legal);
    }
  }
};

/*
Background video
*/
var setBgVideoSrc = function(){
  $('.feature-bg-video,.header-bg-video').each(function(){
    if ($w.width() < app.breakpoints.md) {
      $(this).html('');
    }else{
      if (!$(this).find('source').length) {
        $(this).append('<source src="' + $(this).data('src') + '" type="video/mp4"></source>');
      }
    }
  });
};

updateFooterDom();
setBgVideoSrc();
$w.on('resize', function(){
  updateFooterDom();
  setBgVideoSrc();
});

/*
Modal
*/
$('.modal').fitVids();
$b.on('click', '.modal-trigger', function(e){
  e.preventDefault();
  var $target = $($(this).attr('href'));
  $target.addClass('shown');
  $target.find('.modal-close').focus();
  $target.trigger('modal:shown');
});
$b.on('click', '.modal-body, .modal .body', function(e){
  e.stopPropagation();
});
$b.on('click', '.modal, .modal-close', function(e){
  e.preventDefault();
  modalClose();
});

/*
Tooltips
*/
$('[data-toggle="tooltip"]').tooltip();

/*
Form Embeds
*/
if ($('.external-embed').length) {
  $('.external-embed iframe').iFrameResize({
    // log: true,
    heightCalculationMethod: 'taggedElement',
    checkOrigin: ['https://safariland.test','https://inside.safariland.com','https://dev.inside.safariland.com']
  });
}

/*
Show a back button when coming from finder into education page
*/
if (localStorage.getItem('holster_finder_selections')) {
  $('.education-back.holsters').removeClass("d-none").append(' to holster finder');
}
if (localStorage.getItem('comms_configurator_selections')) {
  $('.education-back.comm').removeClass("d-none").append(' to comms configurator');
}
$('.education-back').on('click', function(e){
  history.back();
});

/*
Category Grid
*/
$('.category-grid .btn').on('click', function(e){
  e.preventDefault();
  $(this).closest('.category-grid').next().removeClass('d-none');
  $(this).remove();
});

// report the index of a  product list click to GTM to trigger select_item. data for select_item will be in dlProductList
// this happens on collection pages, gun landing pages, and in the finder
$b.on('click', '#results .product-item', function(){
	dataLayer.push({
		"dl_selectedIndex" : $(this).data('index'),
		"event" : "productList_click"
	});
});